import { primaryGridItemStyle, XLPrimaryGridItemStyle } from './PrimarySection.ve.css';

export const primaryGridItemStyles = {
    className: primaryGridItemStyle,
    tabIndex: 0,
};

export const XLPrimaryGridItemStyles = {
    className: XLPrimaryGridItemStyle,
    tabIndex: 0,
};
